import ViewModes from './ViewModes';

export default ViewModes;
